import axios from "axios";
import appConfig from "configs/app.config";
import {PERSIST_STORE_NAME} from "constants/app.constant";
import deepParseJson from "utils/deepParseJson";
import {
    REQUEST_HEADER_AUTH_KEY,
    REQUEST_LOGIN_URI,
    REQUEST_REFRESH_TOKEN_URI,
    TOKEN_TYPE, UNAUTHORIZED_CODE, USER_REQUEST_HEADER_AUTH_KEY
} from "constants/api.constant";
import store from "store";
import {onSignOutSuccessAdmin, setTokenAdmin} from "store/auth/sessionSlice";
import {addLoading, removeLoading} from "../store/base/commonSlice";
import {onSignOutSuccess} from "../store/userAuth/sessionSlice";

let originalConfig = {url: ''};

const BaseService = axios.create({
    timeout: 60000,
    baseURL: appConfig.apiPrefix,
    headers: {
        "Content-Type": "application/json",
    },
});

BaseService.interceptors.request.use(
    (config) => {
        const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME)
        const persistData = deepParseJson(rawPersistData)

        store.dispatch(addLoading(config.url))
        const accessToken = persistData.auth.session.accessToken
        const accessTokenUser = persistData.userAuth.session.accessToken

        if (accessToken) {
            config.headers[REQUEST_HEADER_AUTH_KEY] = `${TOKEN_TYPE}${accessToken}`
        }
        if (accessTokenUser) {
            config.headers[USER_REQUEST_HEADER_AUTH_KEY] = `${accessTokenUser}`
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

BaseService.interceptors.response.use(
    (res) => {
        store.dispatch(removeLoading(res.config.url))
        return res;
    },
    async (err) => {
        originalConfig = err.config || {};
        store.dispatch(removeLoading(err.config.url))

        if (originalConfig.url !== REQUEST_LOGIN_URI && err.response) {
            // Access Token was expired
            if (UNAUTHORIZED_CODE.includes(err.response.status) && !originalConfig._retry) {
                store.dispatch(onSignOutSuccess())
                store.dispatch(onSignOutSuccessAdmin())

                // originalConfig._retry = true;
                // const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME)
                // const persistData = deepParseJson(rawPersistData)
                // const refreshToken = persistData.auth.session.refreshToken

/*                try {
                    const rs = await BaseService.post(
                        REQUEST_REFRESH_TOKEN_URI,
                        {
                            refreshToken: refreshToken,
                        }
                    );

                    store.dispatch(setTokenAdmin(rs.data.data))
                    store.dispatch(removeLoading(err.config.url))

                    return BaseService(originalConfig);
                }
                catch (_error) {
                    store.dispatch(removeLoading(err.config.url))
                    return Promise.reject(_error);
                }*/
            }
        }

        store.dispatch(removeLoading(err.config.url))
        return Promise.reject(err);
    }
);

export default BaseService;

